import React, { useState, useEffect, useRef } from 'react'
import { CLIENT_DATA } from '../../helpers/constants'
const delay = 5500

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  const [itemIndex, setItemIndex] = useState(0)
  const timeoutRef = useRef(null)

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
  }

  useEffect(() => {
    resetTimeout()
    timeoutRef.current = setTimeout(
      () => setItemIndex((prevIndex) => (prevIndex === CLIENT_DATA.length - 1 ? 0 : prevIndex + 1)),
      delay
    )
    return () => {
      resetTimeout()
    }
  }, [itemIndex])
  return (
    <div data-section='client-carousel'>
      <p data-type='subtitle'>Our Clients Include</p>
      <div data-type='slideshow'>
        <div
          data-type='slider'
          style={{
            transform: `translate3d(${-itemIndex * 100}%, 0, 0)`,
          }}
        >
          {CLIENT_DATA.map(({ images }, index) => (
            <div data-type='slide' key={index} data-style={itemIndex === index ? 'active' : ''}>
              <div data-type='wrapper'>
                {images.map((image, i) => (
                  <picture data-type='image' key={i}>
                    <img
                      width='225'
                      height='125'
                      itemProp='image'
                      className='lazyload'
                      data-src={image}
                      alt='client'
                      role='presentation'
                      data-type='image'
                    />
                  </picture>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div data-type='dots'>
          {CLIENT_DATA.map((data, idx) => (
            <div
              key={idx}
              data-type='dot'
              data-style={itemIndex === idx ? 'active' : ''}
              onClick={() => {
                setItemIndex(idx)
              }}
              role='button'
              tabIndex='0'
              onKeyDown={() => {
                setItemIndex(idx)
              }}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default Component